import { render, staticRenderFns } from "./VvMobileTasteTile.vue?vue&type=template&id=c1b4f080&scoped=true&"
import script from "./VvMobileTasteTile.vue?vue&type=script&lang=js&"
export * from "./VvMobileTasteTile.vue?vue&type=script&lang=js&"
import style0 from "./VvMobileTasteTile.vue?vue&type=style&index=0&id=c1b4f080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4f080",
  null
  
)

export default component.exports